module.exports = __webpack_public_path__ + "img/sbb-dawn.91c09bda.jpg";